var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('transition-group',{staticClass:"draged_elems",attrs:{"name":"list","tag":"div"}},_vm._l((_vm.filtredEvents),function(n){return _c('drag',{key:n.node.eventId,staticClass:"item",attrs:{"data":n}},[_vm._v(_vm._s(n.node.distance)+" "+_vm._s(n.node.stroke))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }